import { css } from 'lit';
import { CzContentloader } from '@cz/webcomponents';

export default class CzAvtableloader extends CzContentloader {

	static styles = [
		CzContentloader.styles,
		css`
			@layer component {
				:host(:empty) {
					aspect-ratio: 1/.325;
				}
			}
		`
	];

	static properties = {
		brand: {},
		year: {},
		language: {},
		category: {},
		collectivity: {}
	};

	#meldingOphalenGegevens = 'Geen gegevens gevonden';
	#meldingAVNietGevonden = 'Geen aanvullende verzekering gevonden';
	#avTitle = 'Aanvullende verzekering';
	#tvTitle = 'Tandarts verzekering';
	#vergoedingTitle = 'Vergoeding';

	updated(changedProperties) {
		if (changedProperties?.has('brand') ||
			changedProperties?.has('year') ||
			changedProperties?.has('language') ||
			changedProperties?.has('category') ||
			changedProperties?.has('collectivity')) {
			this.innerHTML = '';
			this.loadContent();
		}
	}

	callBackend = async (url) => {
		try {
			const requestUrl = `${url}?site=${this.brand?.toLowerCase()}&language=${this.language}&year=${this.year?.toLowerCase()}&categoryId=${this.category?.toLowerCase()}&collectivity=${this.collectivity?.toLowerCase()}`;
			const controller  = window.AbortController ? new AbortController() : {};
			const signal = controller.signal || {};
			const fetchPromise = fetch(requestUrl, {
				signal,
				method: "GET",
				headers: {
				  "Content-Type": "application/json; charset=utf-8",
				},
				credentials: "same-origin",
			  });
			const response = await fetchPromise;
			if (!response.ok) {
				return this.#errorNotification(this.#meldingAVNietGevonden);
			}
			let result = await response.json();
			return this.#bakeHtmlFromJsonResult(result);
		} catch (error) {
			return this.#errorNotification(this.#meldingOphalenGegevens);
		}
	}

	#errorNotification(message) {
		return `<div class="c-notification c-notification--error">
					<span>${message}</span>
				</div>`;
	}

	#bakeHtmlFromJsonResult(result) {
        let returnValue = '';
        if (result) {
            if (result.aanvullend && result.aanvullend.length > 0) {
                returnValue += this.#bakeTable(result.aanvullend, `<table class="c-table"><tr><th>${this.#avTitle || 'Aanvullende verzekering' }</th><th>${this.#vergoedingTitle || 'Vergoeding'}</th></tr>`, '</table>');
            }
            if (result.tand && result.tand.length > 0) {
                returnValue += this.#bakeTable(result.tand, `<table class="c-table"><tr><th>${this.#tvTitle || 'Tandarts verzekering'}</th><th>${this.#vergoedingTitle || 'Vergoeding'}</th></tr>`, '</table>');
            }
        }
        return returnValue;
    }

    #bakeTable(keyValueArray, startSequence, endSequence) {
        let returnValue = keyValueArray.reduce((prev, current) => `${prev}<tr><td>${current.commercieleNaam}</td><td>${current.vergoeding}${current.vergoedingDetails?.reduce((prev, line) => `${prev}${line}<br>`,'<br>') || ''}</td></tr>`, startSequence);
        return returnValue + endSequence;
    }

	constructor() {
		super();
		this.#meldingOphalenGegevens = this.dataset?.meldingOphalenGegevens;
		this.#meldingAVNietGevonden = this.dataset?.meldingAvNietGevonden;
		this.#avTitle = this.dataset?.avTitle;
		this.#tvTitle = this.dataset?.tvTitle;
		this.#vergoedingTitle = this.dataset?.vergoedingTitle;
	}
}

customElements.define('cz-avtableloader', CzAvtableloader);